import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TSegmentLink } from './models';

export const SegmentLink: FC<TSegmentLink> = props => {
    const { BannerLink, link, onClick, selected, styles, title } = props;

    return (
        <span className={cn(styles.topRow)} onClick={onClick}>
            <BannerLink link={link} selected={selected} title={title}>
                {title}
            </BannerLink>
        </span>
    );
};
